import { render, staticRenderFns } from "./CatFooter.vue?vue&type=template&id=3996498f&scoped=true&"
import script from "./CatFooter.vue?vue&type=script&lang=ts&"
export * from "./CatFooter.vue?vue&type=script&lang=ts&"
import style0 from "./CatFooter.vue?vue&type=style&index=0&id=3996498f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3996498f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardText,VFooter,VIcon,VImg})
